import { makeStyles } from '@mui/styles'
import {
  AQUA_GREEN,
  GRAYISH_BLUE,
  LIGHT_GRAY,
  NEON_BLUE_LIGHT,
  RAVEN,
  SILVER_SAND,
  WHITE,
} from '@returnmates/client-core/src/constants/colors'
import { URBANIST } from '@returnmates/ui-core/src/constants/styles/fonts'

const useStyles = makeStyles(() => ({
  checkboxFilterWrapper: {
    position: 'relative',
  },
  filterContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  filtersCount: {
    background: AQUA_GREEN,
    padding: '2px 5px',
    borderRadius: 5,
    fontSize: 14,
    fontWeight: 700,
    fontFamily: URBANIST,
    color: WHITE,
    margin: '0 3px 0 5px',
  },
  checkBoxFilterButton: {
    width: 'fit-content',
    height: 40,
    display: 'flex',
    justifyContent: 'space-between',
    fontFamily: URBANIST,
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '19.6px',
    color: RAVEN,
    backgroundColor: '#FFFFFF',
    padding: '8px 7px',
    textTransform: 'initial',
    borderRadius: 5,
    '&:hover': {
      backgroundColor: LIGHT_GRAY,
    },
    '& > span': {
      marginRight: -5,
      marginLeft: 2,
    },
  },
  filterActiveButton: {},
  disabledButton: {
    background: '#FFFFFF !important',
    color: 'rgba(146, 155, 172, 0.9) !important',
  },
  filterIconActive: {
    transform: 'rotate(180deg)',
    '& > path': {
      stroke: NEON_BLUE_LIGHT,
    },
  },
  checkboxFilterPaper: {
    position: 'absolute',
    top: 42,
    zIndex: 101,
    width: 'max-content',
    minWidth: 200,
    maxHeight: 500,
    overflowY: 'auto',
    left: -10,
    background: '#FFFFFF',
    opacity: 1,
    border: `1px solid ${SILVER_SAND}`,
    borderRadius: 3,
    animation: `$fadeInDown 0.3s ease-out`,
    boxShadow: '3px 4px 4px 0px #00000040',
  },
  checkboxWrapper: {
    padding: '0 5px',
  },
  checkbox: {
    fontFamily: URBANIST,
    color: NEON_BLUE_LIGHT,
    '&.MuiCheckbox-colorSecondary.Mui-checked': {
      color: NEON_BLUE_LIGHT,
    },
  },
  checkboxWrapperLabels: {
    fontFamily: URBANIST,
    fontSize: 13,
    lineHeight: '150%',
    color: RAVEN,
  },
  isAllSelected: {
    position: 'sticky',
    top: 0,
    backgroundColor: '#FFFFFF',
    zIndex: 5,
  },
  searchInput: {
    margin: '0 15px',
    maxWidth: 250,
    position: 'sticky',
    top: 42,
    backgroundColor: '#FFFFFF',
    zIndex: 5,
    '& input': {
      padding: '10px 20px',
    },
  },
  searchIcon: {
    minWidth: 24,
  },
  closeIcon: {
    '& path': {
      stroke: GRAYISH_BLUE,
    },
  },
}))

export default useStyles
